// import React from 'react';
// import { useGLTF } from '@react-three/drei';

export default function TShirtPlaceholder(props: any) {
    // Basic placeholder if model fails to load or for default view
    // returns a box or null
    return (
        <mesh {...props}>
            <boxGeometry args={[1, 1, 1]} />
            <meshStandardMaterial color="gray" wireframe />
        </mesh>
    );
}
